import { gql, useQuery } from '@apollo/client';
import { ModalProps } from '@chakra-ui/react';
import * as React from 'react';

import { LikesModal } from '@/components/Post/components/LikesModal';

import {
  PostLikesModal_GetPost,
  PostLikesModal_GetPostVariables,
} from './graphql-types/PostLikesModal_GetPost';

const GET_POST = gql`
  query PostLikesModal_GetPost($postId: String!) {
    postV2(input: { id: $postId }) {
      result {
        _id
        reactions {
          _id
          ...LikesModal_ReactionFragment
        }
      }
    }
  }
  ${LikesModal.reactionFragment}
`;

export const PostLikesModal: React.FC<
  Omit<ModalProps, 'children'> & {
    postId: string;
  }
> = ({ postId, ...modalProps }) => {
  const { data } = useQuery<
    PostLikesModal_GetPost,
    PostLikesModal_GetPostVariables
  >(GET_POST, {
    variables: { postId: postId },
    skip: !modalProps.isOpen,
    fetchPolicy: 'cache-and-network',
  });
  return (
    <LikesModal
      {...modalProps}
      reactions={data?.postV2?.result?.reactions || []}
    />
  );
};
